import { useStore } from '@/store';
import { getAllPresetNames } from '@utils/dependencyLoader/preset-registry';
import useDepLoader from '@composables/useDepLoader';
import dependencyLoader from '@/utils/dependencyLoader';
import moduleRegistry from '@/utils/dependencyLoader/module-registry';
import { onUnmounted } from '@vue/composition-api';
const allPresets = getAllPresetNames();
export const handleAiPageConfig = (externals) => {
    const dependencies = new Set();
    externals.forEach((dependency) => {
        if (dependency.startsWith('@wuji-go')) {
            return;
        }
        if (allPresets.includes(dependency)) {
            return;
        }
        dependencies.add(dependency);
    });
    return dependencies;
};
const AI_PAGE_ID = 'wuji-ai-page_deps';
const FETCH_PREVIEW_DEPENDENCY_TYPE = '__fetch_preview_dependency__';
const EDITOR_UPDATE_DEPENDENCY_TYPE = '__editor-update-dependency__';
const useAiDepLoader = () => {
    const { updateDependency } = useDepLoader();
    const loadAIPageDependency = async (runtime = false, framework = 'vue3') => {
        const store = useStore();
        const dependency = runtime ? store.state.runtime.project.dependency : store.state.project.projectInfo.dependency;
        const externals = dependency?.pages?.[AI_PAGE_ID] || [];
        const deps = handleAiPageConfig(externals);
        await dependencyLoader.init(framework, dependency?.pages, dependency?.packageJson);
        const { bundle } = dependency || { bundle: { js: '' } };
        await moduleRegistry.load({ bundle });
        if (deps.size > 0) {
            await dependencyLoader.load(AI_PAGE_ID, Array.from(deps));
        }
        return new Promise((resolve) => {
            const searchParams = new URLSearchParams(window.location.search);
            const isPreview = searchParams.get('wujiAiPageUK');
            if ((window.opener || window.parent || window.top) && isPreview) {
                const channel = new MessageChannel();
                (window.opener || window.parent || window.top)?.postMessage({
                    type: FETCH_PREVIEW_DEPENDENCY_TYPE,
                    port: channel.port2,
                }, '*', [channel.port2]);
                channel.port1.onmessage = (e) => {
                    if (e.data.type === EDITOR_UPDATE_DEPENDENCY_TYPE) {
                        const { bundle, dependencies } = e.data;
                        moduleRegistry.load({ bundle, dependencies }).then(() => {
                            resolve(true);
                        });
                    }
                    channel.port1.close();
                };
                channel.port1.start();
            }
            else {
                resolve(true);
            }
        });
    };
    const updateAIPageDependency = (externals) => {
        const dependencies = handleAiPageConfig(externals);
        return updateDependency(dependencies, AI_PAGE_ID);
    };
    return {
        loadAIPageDependency,
        updateAIPageDependency,
    };
};
export const useEditorDepLoader = () => {
    const handleMessage = (e) => {
        if (e.data.type === FETCH_PREVIEW_DEPENDENCY_TYPE) {
            const { port } = e.data;
            const { bundle, allDependencies } = dependencyLoader.getInfo();
            port.postMessage({
                type: EDITOR_UPDATE_DEPENDENCY_TYPE,
                bundle,
                dependencies: allDependencies,
            });
        }
    };
    window.addEventListener('message', handleMessage);
    onUnmounted(() => {
        window.removeEventListener('message', handleMessage);
    });
};
export default useAiDepLoader;
